export default __webpack_public_path__ + "static/leafHorizontal-4d453e61a8753752a6d20f0c3dc19972.svg";